import React, { Component } from 'react';
import { ListLayout } from '../containers/Layout';
import { isEmpty } from "lodash";
import Spin from '../../../../commonModules/interface/Spin';
import { InputSelect } from '../../../../commonModules/interface/form-input-inline';
import { TableRow, Button, TableCell, TableHead, Box, TableBody, IconButton } from '@material-ui/core';
import { AddRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';

class ListComReturn extends Component{
    state = {
        filteredList: [],
        selectSearchDisplay: {}, 
        selectSearch: "",


        deletePopUp: false,
        toDelete:{
            id:""
        },
        mdpAdmin: "",
        errors:{
            mdpAdmin: "",
        },

    }

    createReapproList(){
        const { COMMERCIAL_RETURNS, SHOPS, AGENTS, currentPageReturn, rowsPerPage } = this.props
        const { selectSearch } = this.state;
        let list = selectSearch ? this.commercialFilter(selectSearch) : Object.values(COMMERCIAL_RETURNS)
        
        return [list.slice(currentPageReturn * rowsPerPage, currentPageReturn * rowsPerPage + rowsPerPage).map( reappro => { 
            const commercial = AGENTS && AGENTS[reappro.commercial_id]
            const shop = SHOPS[reappro.shop_id] || {}

            return (        
                <TableRow key={reappro.id}>
                    {/* <TableCell>{reappro.id}</TableCell> */}
                    <TableCell>{(new Date(reappro.date)).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>
                        <a href="#" onClick={ ()=> this.props.handleSingleShop(shop) }> {shop.name}</a>
                    </TableCell>
                    <TableCell>
                        {commercial && 
                        <a href="#" onClick={ ()=> this.props.handleSingleCom(commercial.id) }> 
                            {commercial.name}
                        </a>
                        }
                    </TableCell>
                    
                    <TableCell>
                        <IconButton 
                            // className="btn bgm-teal" 
                            color="secondary"
                            onClick={() => this.props.handleSingleComReturn(reappro, shop, commercial)}
                        >
                            <AddRounded />
                        </IconButton>
                    </TableCell>
                </TableRow>
            )            
        }), list.length]
    }

    createCommercialList = () => {
        const { AGENTS, COMMERCIAL_RETURNS } = this.props
        let list = []
        let comID = []

        if( AGENTS ){
            Object.values(COMMERCIAL_RETURNS).forEach( item => {
                if( !comID.includes(item.commercial_id)) {
                    comID.push(item.commercial_id)
                }
            })
            
            comID.forEach( agentID => { 
                let agent = AGENTS[agentID] || {}
                let selected = false
                if(this.state.selectSearch === agent.id) {  // already selected   
                    selected = true 
                } 
                list.push (       
                    {value:agent.id, label:agent.name, disabled:selected} 
                )
            })
        }

        return list
    }

    commercialFilter(selected){
        const { COMMERCIAL_RETURNS } = this.props
        
        let filteredCommercial = Object.values(COMMERCIAL_RETURNS).filter( 
            rea => rea.commercial_id === selected
        )

        return filteredCommercial
    }

    render(){
        const commercials = this.createCommercialList()
        let list = [[], 0]
        if (!isEmpty(this.props.COMMERCIAL_RETURNS) ){
            list = this.createReapproList()
        }
        return (
            <React.Fragment>
                <div>
                    <Box p={2}>
                        <InputSelect
                            options={commercials}
                            value={this.state.selectSearchDisplay}
                            label="Sélectionner un Commercial"
                            onChange={ option => 
                                this.setState({ 
                                    selectSearchDisplay: option, 
                                    selectSearch:option.value
                                })
                            }
                        /> 
                    </Box>
                    <ListLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" >Date</TableCell>
                                <TableCell component="th" >Shop</TableCell>
                                <TableCell component="th" >Commercial</TableCell>                                
                                <TableCell component="th" colSpan={2}>Détails</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list[0]}
                            { isEmpty(this.props.COMMERCIAL_RETURNS) && this.props.STATE.commercialReturns.fetching &&
                                <Spin noOverlay />
                            }
                            { this.props.STATE.commercialReturns.fetching &&
                                <Spin />
                            }
                            { isEmpty(this.props.COMMERCIAL_RETURNS) && this.props.STATE.commercialReturns.fetched &&
                            <TableRow>
                                <TableCell colSpan="7">
                                    <div className="text-center">
                                        <h5>Pas de Retour Commercial</h5> 
                                        Cliquez sur <b className="onglet">"Retour"</b> Pour en créer un
                                    </div>
                                </TableCell>
                            </TableRow>
                            }
                        </TableBody>
                        { list[1] > 20 && 
                            <TableFooterPagination
                                colSpan={5}
                                items={list[0]}
                                count={list[1]}
                                onChangePage={this.props.onChangePage}
                                initialPage={this.props.currentPageReturn || 0}
                            />
                        }
                    </ListLayout>                                             
                </div>
            </React.Fragment>
        )
    }
}



export default ListComReturn